import React, { useState, useEffect } from 'react'
import { useStoreActions } from 'easy-peasy'
import { useParams } from 'react-router-dom'

import { useHistory } from 'react-router-dom'
import Latency from '../Components/Latency'
import Store360Body from './Body'

const Store360 = () => {
  const { id } = useParams()
  const history = useHistory()

  const { setBreadCrumb } = useStoreActions((actions: any) => actions.breadcrumb)

  useEffect(() => {
    if (id) {
      setBreadCrumb([
        {
          title: 'Analytics',
          path: `/analytics/sale-campaigns?${history.location.search}`,
        },
        { title: 'Sale Channel', path: `/analytics/store360/${id}` },
      ])
      history.push({ search: '' })
    }
  }, [setBreadCrumb, id, history])

  if (!id) return null

  return (
    <div className="AnalyticsWrapper px-8 py-7 w-full">
      <span className="text-3xl font-semibold">Store 360</span>
      {/* <div className="mt-8">
        <Latency />
      </div> */}
      <div className="mt-4">
        <Store360Body></Store360Body>
      </div>
    </div>
  )
}

export default Store360
